import { TFunction } from 'i18next';
import { VALIDATION } from '../constants';
import { validatePattern } from './validatePattern';
import { validateMaxLength } from './validateMaxLength';
import { validateMinLength } from './validateMinLength';

export function validateDomainName(t: TFunction) {
	return {
		...validatePattern(
			VALIDATION.domainName.pattern,
			t('invalid_symbols', {
				allowedSymbols: VALIDATION.domainName.allowedSymbols,
			}),
		),
		...validateMaxLength(
			VALIDATION.domainName.maxLength,
			t('domain_name_too_long'),
		),
		...validateMinLength(
			VALIDATION.domainName.minLength,
			t('domain_name_too_short'),
		),
	};
}
